// extracted by mini-css-extract-plugin
export default {"camera":"camera__LJcr3"};